import React, { ButtonHTMLAttributes, forwardRef } from 'react';
import { PlusCircleOutlined } from '@ant-design/icons';
import styles from './FilterChip.module.scss';

export interface FilterChipButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  /** Nazwa filtra („Status”); w stanie ustawionym przycisk czyta się „Status: Aktywna”. */
  label: string;
  /** Opis ustawionej wartości albo `null`, gdy filtr jest wyłączony. */
  valueLabel: string | null;
}

/**
 * Sam przycisk „pigułki” filtra: bez wartości przerywana ramka z plusem, po wyborze pełna ramka
 * z wartością. Dropdown (`FilterChip`) i własne okna (np. zakres dat) dokładają zachowanie na zewnątrz.
 */
const FilterChipButton = forwardRef<HTMLButtonElement, FilterChipButtonProps>(
  ({ label, valueLabel, className, ...rest }, ref) => (
    <button
      {...rest}
      ref={ref}
      type="button"
      className={[styles.chip, valueLabel !== null && styles.set, className]
        .filter(Boolean)
        .join(' ')}
    >
      {valueLabel !== null ? (
        <span>
          {label}: <strong className={styles.value}>{valueLabel}</strong>
        </span>
      ) : (
        <>
          <PlusCircleOutlined className={styles.icon} aria-hidden />
          {label}
        </>
      )}
    </button>
  )
);

FilterChipButton.displayName = 'FilterChipButton';

export default FilterChipButton;
